import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetNavigationHeaderResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import {CategoryHeader as CategoryHeaderUI} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {FiltersHeaderLoading} from '../../../features/Filters/FiltersHeader/FiltersHeaderLoading';
import {useHeaderData, useNormalizedHeaderData} from './helpers';

export const CategoryHeader: FC<
  PriorityConfig & {title?: string; seoSubline?: string}
> = ({renderingPriority, ...viewProps}) => {
  return (
    <DataFetcher
      request={useHeaderData()}
      Error={() => null}
      Loading={FiltersHeaderLoading}
      View={FiltersHeaderView}
      viewProps={viewProps}
      renderingPriority={renderingPriority}
    />
  );
};

const FiltersHeaderView: React.FC<GetNavigationHeaderResponse> = props => {
  const {backPath, onBack, categoryName} = useNormalizedHeaderData({
    parentCategory: props.parentCategory,
    category: props.category,
    alternativeSeoCategoryName: props.alternativeSeoCategoryName,
  });

  return (
    <CategoryHeaderUI
      backTarget={backPath}
      onBack={onBack}
      centered
      sidePadding
      stickyOnScrollUp={false}
      categoryName={categoryName}
      subtitle={props.seoSubline}
    />
  );
};
